import { render } from "./FireAssignmentLabel.vue?vue&type=template&id=211d978a&scoped=true"
import script from "./FireAssignmentLabel.vue?vue&type=script&lang=ts"
export * from "./FireAssignmentLabel.vue?vue&type=script&lang=ts"

import "./FireAssignmentLabel.vue?vue&type=style&index=0&id=211d978a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-211d978a"

export default script